@if (!editMode) {
  <div>
    @if (data !== undefined && data.length > 0) {
      <img [src]="data" class="rounded-circle" />
    }
    @if (data === undefined || data.length === 0) {
      <div>No Image</div>
    }
  </div>
} @else {
  <mat-form-field [formGroup]="formGroup" class="example-full-width">
    @if (data !== undefined && data.length > 0) {
      <img [src]="data" class="rounded-circle" />
    }
    @if (data === undefined || data.length === 0) {
      <input readonly formControlName="{{ fieldConfig.name }}" matInput value="No Image" />
    }
  </mat-form-field>
}
